export enum IScheduleMode {
  Minute,
  Hourly,
  Daily,
  Weekly,
  Monthly,
  Yearly,
  Once,
}
